(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-1"]) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section-header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-2"]) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section-header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-3"]) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section-header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-4"]) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section-header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-5"]) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section-header-2'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-6"]) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section-header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();
})();
